export default {
  deactivate: '/deactivate',
};
